import * as at from '../actionTypes'
import {updateUserData} from '../actions'

export const getAllUserData = (api, data, dispatch) => {
  return new Promise((resolve, reject) => {
    api
      .post('getuserdata', data)
      .then((response) => {
        if (response) {
          if (response.status === at.API_OK) {
            dispatch(updateUserData(response.data))
            resolve(response)
            return
          } else {
            console.log('Error getting user data from server!', response.msg)
            reject(response)
            return
          }
        }
        console.log('Error getting user data from server! No Response')
        reject(response)
      })
      .catch((err) => {
        console.log('Error getting user data from server!', err)
        reject(err)
      })
  })
}

export const syncDefaultNumbers = (api, defaults) => {
  return new Promise((resolve, reject) => {
    api
      .post('savedefaultnumbers', defaults)
      .then((response) => {
        if (response) {
          if (response.status === at.API_OK) {
            resolve(response)
            return
          } else {
            console.log('Error saving default numbers to server', response.msg)
            window.alert(`Failed to save default numbers!`)
            reject(response)
            return
          }
        }
        window.alert('Failed to save default numbers!')
        reject(response)
      })
      .catch((err) => {
        console.log('Error saving default numbers to server', err)
        window.alert('Error Connecting to server!')
        reject(err)
      })
  })
}

export const syncUserData = (api, data, dispatch, type) => {
  const typeWithoutSpacesAndLowercase = type.toLowerCase().replace(/\s/g, '')
  return new Promise((resolve, reject) => {
    api
      .post('save' + typeWithoutSpacesAndLowercase, data)
      .then((response) => {
        if (response) {
          if (response.status === at.API_OK) {
            dispatch(updateUserData(response.data))
            resolve(response)
            return
          } else {
            console.log(`Error saving ${type} to server`, response.msg)
            window.alert(`Failed to save ${type}!`)
            reject(response)
            return
          }
        }
        window.alert(`Failed to save ${type}!`)
        reject('')
      })
      .catch((err) => {
        console.log(`Error saving ${type} to server`, err)
        window.alert('Error Connecting to server!')
        reject(err)
      })
  })
}

export const syncObjectDelete = (api, data, dispatch, type) => {
  const typeWithoutSpacesAndLowercase = type.toLowerCase().replace(/\s/g, '')
  return new Promise((resolve, reject) => {
    api
      .post('delete' + typeWithoutSpacesAndLowercase, data)
      .then((response) => {
        if (response) {
          if (response.status === at.API_OK) {
            dispatch(updateUserData(response.data))
            resolve(response)
            return
          } else {
            console.log(`Error deleteing ${type} from server`, response.msg)
            reject(response)
            return
          }
        }
        window.alert(`Failed to deleteing ${type}!`)
        reject('')
      })
      .catch((err) => {
        console.log(`Error deleting ${type} from server`, err)
        window.alert('Error Connecting to server!')
        reject('')
      })
  })
}



// WEBPACK FOOTER //
// ./src/helpers/syncing.js